import arrowup from "./arrowup.svg";
import arrowdown from "./arrowdown.svg";
import setting from "./setting.svg";
import greentick from "./greenTick.svg";
import search from "./search.svg";
import rightarrow from "./rightarrow.svg";
import blacksetting from "./blacksetting.svg";
import warn from "./warn.svg";
import arrowleftBlack from "./arrowLeftBlack.svg";
import arrowrightBlack from "./arrowRightBlack.svg";
import greenTick2 from "./greenTick2.svg";

export const icons = {
  arrowdown,
  arrowup,
  setting,
  greentick,
  search,
  rightarrow,
  blacksetting,
  warn,
  arrowleftBlack,
  arrowrightBlack,
  greenTick2,
};
